import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

const ModalWindow = (props: any) => {
    const { className, backdrop, onCancel } = props;
    const backdropAttribute = backdrop ? 'static' : true;
    const toggle = () => {
        onCancel();
    };

    return (
        <Modal isOpen={true} toggle={toggle} className={className} backdrop={backdropAttribute}>
            <ModalHeader toggle={toggle}>{props.title}</ModalHeader>
            <ModalBody>
                {props.children}
            </ModalBody>
        </Modal>
    );
}

export default ModalWindow;